var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.545074 1.25059C0.299215 0.758873 0.49464 0.557618 1.00036 0.810479L18.9608 9.79068C19.4581 10.0393 19.4632 10.462 18.9929 10.7233L1.67391 20.345C1.19442 20.6114 0.966457 20.4094 1.16344 19.8972L4.3345 11.6524L14.2151 10.2409L4.33451 8.82937L0.545074 1.25059Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/ChatSend.ddeac64e3ff881c0ae45e4bafa878b6c.svg";
export { ForwardRef as ReactComponent };